export default __webpack_public_path__ + "static/media/logo-full.be13ef4a.png";